import { getSortedFormFields } from '@utils/forms';
import { apiIssuesOptions, partnerApiIssuesOptions } from './DeveloperPortalSupportFormOptions';

export const getDeveloperPortalSupportFormData = (target, helpWith, helpWithSecondary) => {
  let namespace: string;
  const subject: string = `DeveloperPortal : ${helpWith} - ${helpWithSecondary} - {formId}`;;

  switch (helpWithSecondary) {
    case apiIssuesOptions.computeOpsManagement:
      namespace = 'hpe_devportal_compute';
      break;
    case apiIssuesOptions.auditLogs:
    case apiIssuesOptions.authorization:
    case apiIssuesOptions.devices:
    case apiIssuesOptions.hpeGreenLake:
    case apiIssuesOptions.identity:
    case apiIssuesOptions.locationManServ:
    case apiIssuesOptions.subscriptions:
    case apiIssuesOptions.wellness:
    case apiIssuesOptions.workspace:
      namespace = 'hpe_greenlake_api_portal';
      break;
      // case apiIssuesOptions.hpeGreenLakeFlex:
    case partnerApiIssuesOptions.partnerBilling:
      namespace = 'hpe_devportal_glcentral';
      break;
    default:
      namespace = 'hpe_devportal';
      break;
  }

  return getSortedFormFields(target, namespace, subject);
};
